import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from './header';
import PostsContainer from '../container';
import Cookies from 'js-cookie';
import get from 'lodash/get';

export default class Insert extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false
    };
  }
  shouldComponentUpdate() {
    return false;
  }

  setActive() {
    this.state.active = true;
    this.forceUpdate();
  }

  render() {
    const {
      config,
      tags,
      postData,
      related,
      isDesktop,
      isFirstPost,
      pageNum,
      combinedAdModel,
      videoAdData,
      live,
      updateCorrelator,
      insert
    } = this.props;
    const abGroupCookie = Cookies.get('abgroup');

    return (
      <div className="article__insert">
        <div>
          {this.state.active || abGroupCookie !== '21' ? (
            <PostsContainer
              key={get(postData, 'id')}
              posts={[postData]}
              related={related}
              isDesktop={isDesktop}
              pageNum={pageNum}
              combinedAdModel={combinedAdModel}
              config={config}
              videoAdData={videoAdData}
              updateCorrelator={updateCorrelator}
            />
          ) : (
            ''
          )}
          {abGroupCookie === '21' ? (
            <div
              className={
                this.state.active
                  ? 'article__preview--active'
                  : 'article__preview'
              }
            >
              <Header
                tags={tags}
                advertorial={false}
                post={postData}
                combinedAdModel={{}}
                isFirstPost={isFirstPost}
                isLongPost={false}
                isVideoPost={false}
                live={live}
                config={config}
                insert={insert}
              />
              <div
                className="article__preview__body"
                dangerouslySetInnerHTML={{
                  __html: get(postData, 'content[0]')
                }}
              />
              <button onClick={() => this.setActive()}>Read More</button>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    );
  }
}

Insert.defaultProps = {
  isDesktop: false,
  isFirstPost: false,
  related: [],
  updateCorrelator: false,
  live: false
};

Insert.propTypes = {
  config: PropTypes.shape({}).isRequired,
  tags: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  postData: PropTypes.shape({}).isRequired,
  insert: PropTypes.bool.isRequired,
  pageNum: PropTypes.number.isRequired,
  related: PropTypes.arrayOf(PropTypes.shape({})),
  combinedAdModel: PropTypes.shape({}).isRequired,
  isDesktop: PropTypes.bool,
  isFirstPost: PropTypes.bool,
  videoAdData: PropTypes.shape({}).isRequired,
  updateCorrelator: PropTypes.bool,
  live: PropTypes.bool
};
